import { Scalars } from '@bechtel/sr-types';
import React, { PropsWithChildren, useContext } from 'react';
import { IssueCommodity } from '~/components';

export interface ChangeManagementSignature {
  preparedBy: string;
  checkedBy: string;
  approvedBy: string;
}

export interface ChangeManagementPermissions {
  canCheck: boolean;
  canApprove: boolean;
  canPrepare: boolean;
  canIssue: boolean;
}

export interface ChangeManagementToolbarProviderProps {
  id: Scalars['ID'];
  name: string;
  engineeringStatus: string;
  enabled: boolean;
  signature?: ChangeManagementSignature;
  permissions: ChangeManagementPermissions;
  onIssue?: (data: IssueCommodity[]) => void;
}

const ChangeManagementToolbarStateContext: React.Context<ChangeManagementToolbarProviderProps> =
  React.createContext<ChangeManagementToolbarProviderProps>({
    id: '',
    name: '',
    engineeringStatus: '',
    enabled: false,
    signature: {
      preparedBy: '',
      checkedBy: '',
      approvedBy: '',
    },
    permissions: {
      canCheck: false,
      canApprove: false,
      canPrepare: false,
      canIssue: false,
    },
  });

function useChangeManagementToolbar(): ChangeManagementToolbarProviderProps {
  const changeManagementData = useContext(ChangeManagementToolbarStateContext);
  if (typeof changeManagementData === undefined) {
    throw new Error(`useChangeManagementToolbar must be used within a ChangeManagementToolbarProvider`);
  }

  return changeManagementData;
}

function ChangeManagementToolbarProvider(props: PropsWithChildren<ChangeManagementToolbarProviderProps>) {
  const { children, ...rest } = props;
  return (
    <ChangeManagementToolbarStateContext.Provider value={rest}>{children}</ChangeManagementToolbarStateContext.Provider>
  );
}

export { ChangeManagementToolbarProvider, useChangeManagementToolbar };
